export default "__VITE_ASSET__DPiT7IkY__"